import { combineReducers } from 'redux';

import * as $app from 'modules/app';
import { datasetListReducer } from './reducers/datasetList';
import { datasetUpdateReducer } from './reducers/datasetUpdate';

const datasetsReducerBase = combineReducers({
  list: datasetListReducer,
  update: datasetUpdateReducer,
});

export const datasetsReducer = (state, action) => {
  if (action.type === $app.reset().type) {
    state = undefined;
  }

  return datasetsReducerBase(state, action);
};
